import { render, staticRenderFns } from "./EffectPreview.vue?vue&type=template&id=4fce31e0&"
import script from "./EffectPreview.vue?vue&type=script&lang=js&"
export * from "./EffectPreview.vue?vue&type=script&lang=js&"
import style0 from "./EffectPreview.vue?vue&type=style&index=0&id=4fce31e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports